module.exports = __webpack_public_path__ + "static/amazon-data-28820be273ac1d3dad163aa90fdf8855.png";